
  import {
    Component,
    Vue,
    Inject,
    Prop,
    Watch,
    Ref
  } from "vue-property-decorator";

  import api from "@/api";
  import {PaymentCategoryCreateOrEditDto, SwiperDto} from "@/api/appService";
  import { ElForm } from "element-ui/types/form";

  @Component({ name: "EditPaymentCategory" })
  export default class EditPaymentCategory extends Vue {
    @Ref() readonly dataForm!: ElForm;

    @Prop()
    parentId?:number;

    @Prop({required:true})
    scopeMapping!:any;

    @Watch("show")
    async onShowChange(value: boolean) {
      if (value) {
        await api.paymentCategoryService.getForEdit({ id: this.form!.id }).then(res => {
          this.form = {...res.data!};
          if(!this.form.scope){
            this.form.scope = undefined;
          }
        });
      } else {
        this.form = { ...this.defaultData };
      }

      this.$nextTick(() => {
        this.dataForm.clearValidate();
      });
    }



    defaultData: PaymentCategoryCreateOrEditDto = {
      id: undefined,
      /**  */
      displayName: undefined,
      /**  */
      parentId: undefined,

      scope:undefined
    };

    show = false;

    form: PaymentCategoryCreateOrEditDto = { ...this.defaultData };



    async save() {

      (this.$refs.dataForm as any).validate(async (valid: boolean) => {
        if (valid) {
          if (this.form!.id) {
            await api.paymentCategoryService.update({ body: this.form });
          } else {
            if(this.parentId){
              this.form.parentId = this.parentId;
            } else {
              this.form.parentId = undefined;
            }
            await api.paymentCategoryService.create({ body: this.form });
          }
          this.show = false;
          this.$message.success("更新成功");
          this.$emit("onSave");
        }
      });
    }

    cancel() {
      this.show = false;
    }



    categoryRule = {

      displayName: [
        {
          required: true,
          message: "必填",
          trigger: "blur"
        }
      ],
      scope:[
        {
          required:true,
          message:'适用范围是必须的'
        }
      ],
      displayOrder:[
        {
          required:true,
          message:'显示顺序是必填项'
        }
      ]

    };
  }
